module.exports = __webpack_public_path__ + "static/media/hydropurr-2.a8b688c1.jpg";